import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RdsCatalogHeaderComponent } from './catalog-header.component';

@NgModule({
  imports: [CommonModule],
  exports: [RdsCatalogHeaderComponent],
  declarations: [RdsCatalogHeaderComponent],
  providers: [],
})
export class RdsCatalogHeaderModule {}
export * from './catalog-header.component';
